import { FormContextValues } from '@dreryk/react-common';
import { AutoLayout } from '@dreryk/react-components';

import { DateFromDatePicker } from './DateFromDatePicker';
import { DateToDatePicker } from './DateToDatePicker';
import { MedicalDocumentationCreateFormBean } from './MedicalDocumentationCreateForm.types';

type SelectedRangeDateSectionProps = Pick<FormContextValues<MedicalDocumentationCreateFormBean>, 'register' | 'watch'>;

export const SelectedRangeDateSection = ({ register, watch }: SelectedRangeDateSectionProps): JSX.Element => {
   return (
      <AutoLayout as={'div'} $direction={'horizontal'} $horizontalResizing={'fill'} $spacing={24}>
         <AutoLayout
            as={DateFromDatePicker}
            name={'dateFrom'}
            register={register}
            required
            dateTo={watch('dateTo')}
            $horizontalResizing={182}
         />
         <AutoLayout
            as={DateToDatePicker}
            name={'dateTo'}
            register={register}
            required
            dateFrom={watch('dateFrom')}
            $horizontalResizing={182}
         />
      </AutoLayout>
   );
};
